export const promoAction = () => {
    const promos = document.querySelectorAll('.js-promo-action');
    promos.forEach(promo => {

        const promoBtn = promo.querySelector('.promo-banner__info');
        const promoPopup = promo.querySelector('.promo-banner__popup');
        const promoPopupClose = promo.querySelector('.promo-banner__close');
        promoBtn.addEventListener('click', (e) => {
            e.preventDefault();
            promoPopup.classList.toggle('promo-banner__popup--active');
        })
        promoPopupClose.addEventListener('click', (e) => {
            e.preventDefault();
            promoPopup.classList.remove('promo-banner__popup--active');
        })
    })
}